import { useTranslation } from "react-i18next";
import { getButtonsNoYes } from "context/helpers/helperModalContext";
import { useModal } from "context/ModalContext";
import { useRef } from "react";
import { DateTime as DT } from "luxon";

const useChangeDate = () => {

    const { t } =useTranslation();
    const { showDlg } = useModal();
    const refInputDate = useRef();
    const refForm = useRef();
    const paramsDelDlg = {
        buttons : [...getButtonsNoYes(t)], 
        type    : 'confirm',
    }  

    const changeDate = (defValue, cbFunct) => {


        const handleSubmit = async (e) =>{
            e.preventDefault();
            const dt = DT.fromISO(refInputDate.current.value, { zone: 'local' }).toMillis();
            cbFunct(dt);            
            showDlg(false);
        }

        const defDate =   DT.fromMillis(defValue, { zone: 'local' }).toISODate();  


        const p = {
            ...paramsDelDlg,
            text: (<>
                <div style={{marginTop:-25}}>
                    <form onSubmit={handleSubmit}
                        ref={refForm}>
                    <label className="label-control">{t('changeDate')}</label>
                    <input
                        defaultValue={defDate}
                        className="form-control" 
                        required
                        autoFocus
                        ref={refInputDate}
                        type="date"/>
                    <button type="submit" className="d-none"></button>
                    </form>
                </div>
            </>)
        }
        p.buttons[1].handleClick = async () => {  
            if (refForm.current.reportValidity()) {
                refForm.current.requestSubmit();
            }
        }
        showDlg(p);
        
    }

    return {
        changeDate
    }
}

export default useChangeDate;